import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import "@/styles/landing.css";
import "@/styles/theme-lpa.css";
import { SEMINAR } from "@/seminars";
import { VIDEOS } from "@/config/site";
import { LandingProvider, useLanding } from "@/context/LandingContext";
import { useLenis } from "@/hooks/useLenis";
import { ScrollProgress, SiteNav, CompactNav } from "@/components/landing/SiteNav";
import { Hero } from "@/components/landing/Hero";
import { CredibilityStrip, Marquee } from "@/components/landing/Strips";
import { ClaritySection } from "@/components/landing/ClaritySection";
import { WholePlan } from "@/components/landing/WholePlan";
import { Beliefs } from "@/components/landing/Beliefs";
import { Journey } from "@/components/landing/Journey";
import { Scenario } from "@/components/landing/Scenario";
import { VideoSection } from "@/components/landing/VideoSection";
import { Readiness } from "@/components/landing/Readiness";
import { MidCta, Speaker } from "@/components/landing/Speaker";
import { SessionsSection } from "@/components/landing/SessionsSection";
import { Faq } from "@/components/landing/Faq";
import { RegisterSection } from "@/components/landing/RegisterSection";
import { RegistrationModal } from "@/components/landing/RegistrationModal";
import { FloatingWhatsApp, Footer, StickyCtas } from "@/components/landing/Footer";

function LandingContent() {
  const { lenisRef, scrollTo, lang, t } = useLanding();
  const hasVideos = (VIDEOS[lang] || VIDEOS.en || []).length > 0;
  useLenis(lenisRef);

  useEffect(() => {
    const onClick = (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const hash = link.getAttribute("href");
      if (hash.length < 2) return;
      event.preventDefault();
      scrollTo(hash);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [scrollTo]);

  return (
    <div className={`landing theme-${SEMINAR.theme || SEMINAR.id}`} data-testid="landing-page">
      <ScrollProgress />
      <SiteNav />
      <CompactNav />
      <main id="top">
        <Hero />
        <CredibilityStrip />
        <Marquee />
        <ClaritySection />
        <WholePlan />
        <Beliefs />
        {t.scenario && <Scenario />}
        <Journey />
        {hasVideos && <VideoSection />}
        <Readiness />
        <Speaker />
        <MidCta />
        <Faq />
        <SessionsSection />
        <RegisterSection />
      </main>
      <Footer />
      <StickyCtas />
      <FloatingWhatsApp />
      <RegistrationModal />
    </div>
  );
}

export default function Landing() {
  return (
    <MotionConfig reducedMotion="user">
      <LandingProvider>
        <LandingContent />
      </LandingProvider>
    </MotionConfig>
  );
}
